"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_CATEGORY_KEY = 'base';
exports.IMAGE_COMPONENT_KEY = 'image';